import type { ComponentProps } from 'react';

import styles from './count-badge.component.module.scss';

type Props = ComponentProps<'span'> & {
  count: number;
};

export const CountBadge = ({ count, className, ...rest }: Props) => {
  return (
    <span
      aria-label={`未読${count}件`}
      className={[styles.badge, className].filter(Boolean).join(' ')}
      {...rest}
    >
      {count < 100 ? count : '99+'}
    </span>
  );
};

export const InlineCountBadge = ({ count, className, ...rest }: Props) => {
  return (
    <span
      aria-label={`未読${count}件`}
      className={[styles.inlineBadge, className].filter(Boolean).join(' ')}
      {...rest}
    >
      {count < 100 ? count : '99+'}
    </span>
  );
};
